import { render, staticRenderFns } from "./Roof.vue?vue&type=template&id=aafa0db6&scoped=true"
import script from "./Roof.vue?vue&type=script&lang=js"
export * from "./Roof.vue?vue&type=script&lang=js"
import style0 from "./Roof.vue?vue&type=style&index=0&id=aafa0db6&prod&scoped=true&lang=scss"
import style1 from "./Roof.vue?vue&type=style&index=1&id=aafa0db6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa0db6",
  null
  
)

export default component.exports